export enum PhSubregion {
  Metro = "Metro Manila",
  Luzon = "Luzon",
  Visayas = "Visayas",
  Mindanao = "Mindanao",
}

export const phSubregions = Object.values(PhSubregion);
